var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 181,
    viewBox: "0 0 221 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 71,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1696_41984)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 40.3048C105.039 38.8015 110.247 38.7643 115.14 40.1978L201.676 65.5467C207.399 67.2232 207.437 75.3173 201.729 77.0469L115.378 103.214C110.337 104.742 104.95 104.702 99.9323 103.101L18.214 77.0202C12.618 75.2343 12.6564 67.3026 18.2695 65.5709L100.166 40.3048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.333 5.83331H120.958C118.359 5.83331 117.058 8.97456 118.895 10.8121L122.918 14.8341L111.146 26.6058C107.29 30.4616 105.167 35.5891 105.167 41.0433V49.5833H116.833V41.0404C116.833 38.7041 117.743 36.505 119.394 34.8512L131.166 23.0796L135.188 27.1016C137.025 28.9421 140.167 27.6412 140.167 25.0425V11.6666C140.167 8.44373 137.556 5.83331 134.333 5.83331Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8333 11.6666V25.0425C81.8333 27.6412 84.9746 28.9421 86.8121 27.1046L90.8343 23.0823L102.606 34.8512C104.245 36.4933 105.167 38.7187 105.167 41.0375V61.25C105.167 62.86 106.473 64.1666 108.083 64.1666H113.917C115.527 64.1666 116.833 62.86 116.833 61.25V41.0433C116.833 35.6271 114.684 30.4354 110.854 26.6058L99.0825 14.8341L103.105 10.8121C104.942 8.97456 103.641 5.83331 101.042 5.83331H87.6666C84.4437 5.83331 81.8333 8.44373 81.8333 11.6666Z",
    fill: "url(#paint1_linear_1696_41984)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1696_41984",
    x1: 206,
    y1: 126,
    x2: 14,
    y2: 126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1696_41984",
    x1: 83,
    y1: 7.00002,
    x2: 116.25,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.a9e498b03ba65d2335d43569154d3cb4.svg";
export { ForwardRef as ReactComponent };